export default __webpack_public_path__ + "static/media/emblemweb.b4ea0cb0.svg";